<footer class="arcadia-footer">
  <div class="footer-inner">

    
    <div class="footer-top d-none d-lg-grid">

      
      <div class="footer-brand">
        <a routerLink="/">
          <img src="assets/images/logo.svg" alt="Arcadia" class="footer-logo" />
        </a>
        <p class="footer-tagline">
          Tu agencia de viajes de confianza.<br />
          Creando experiencias inolvidables
        </p>
        <div class="footer-socials">
          <a href="https://www.facebook.com/agenciaarcadiaviajes/?locale=es_LA" target="_blank" rel="noopener" aria-label="Facebook">
            <i class="fab fa-facebook-f"></i>
          </a>
          <a href="https://www.instagram.com/arcadia.viajes/" target="_blank" rel="noopener" aria-label="Instagram">
            <i class="fab fa-instagram"></i>
          </a>
          <a href="https://www.tiktok.com/@viajaarcadia?_r=1&_t=ZS-96AqKCnOpIG" target="_blank" rel="noopener" aria-label="TikTok">
            <i class="fab fa-tiktok"></i>
          </a>
          <a href="https://www.linkedin.com/company/arcadia-viajes/" target="_blank" rel="noopener" aria-label="LinkedIn">
            <i class="fab fa-linkedin-in"></i>
          </a>
        </div>
        <a href="mailto:info@arcadia-viajes.com" class="footer-email-link">
          <i class="bi bi-envelope footer-email-icon"></i>
          info&#64;arcadia-viajes.com
        </a>
      </div>

      
      <div class="footer-col">
        <h6 class="footer-col-title">Oficinas</h6>
        <ul class="footer-list">
          <li>
            <button class="footer-accordion-toggle" (click)="toggleSection('venezuela')" [class.open]="openSection === 'venezuela'">
              Venezuela<i class="bi" [ngClass]="openSection === 'venezuela' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
            <ul class="footer-submenu" [class.open]="openSection === 'venezuela'">
              <li class="footer-city-item">
                <span class="footer-city-name">Caracas</span>
                <a href="https://wa.me/584241542685" target="_blank" rel="noopener" class="footer-city-phone">
                  <i class="bi bi-telephone-fill"></i>+58 424 154 2685
                </a>
              </li>
              <li class="footer-city-item">
                <span class="footer-city-name">Valencia</span>
                <a href="https://wa.me/584244097684" target="_blank" rel="noopener" class="footer-city-phone">
                  <i class="bi bi-telephone-fill"></i>+58 424 409 7684
                </a>
              </li>
              <li class="footer-city-item">
                <span class="footer-city-name">Barquisimeto</span>
                <a href="https://wa.me/584245239195" target="_blank" rel="noopener" class="footer-city-phone">
                  <i class="bi bi-telephone-fill"></i>+58 424 523 9195
                </a>
              </li>
              <li class="footer-city-item">
                <span class="footer-city-name">Lechería</span>
              </li>
              <li class="footer-city-item">
                <span class="footer-city-name">San Cristóbal</span>
              </li>
            </ul>
          </li>
          <li>
            <button class="footer-accordion-toggle" (click)="toggleSection('espana')" [class.open]="openSection === 'espana'">
              España<i class="bi" [ngClass]="openSection === 'espana' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
            <ul class="footer-submenu" [class.open]="openSection === 'espana'">
              <li class="footer-city-item">
                <span class="footer-city-name">Madrid</span>
                <a href="https://wa.me/34655204586" target="_blank" rel="noopener" class="footer-city-phone">
                  <i class="bi bi-telephone-fill"></i>+34 655 204 586
                </a>
              </li>
              <li class="footer-city-item">
                <span class="footer-city-name">Barcelona</span>
                <a href="https://wa.me/34655205035" target="_blank" rel="noopener" class="footer-city-phone">
                  <i class="bi bi-telephone-fill"></i>+34 655 205 035
                </a>
              </li>
            </ul>
          </li>
          <li>
            <button class="footer-accordion-toggle" (click)="toggleSection('argentina')" [class.open]="openSection === 'argentina'">
              Argentina<i class="bi" [ngClass]="openSection === 'argentina' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
            <ul class="footer-submenu" [class.open]="openSection === 'argentina'">
              <li class="footer-city-item">
                <span class="footer-city-name">Buenos Aires</span>
                <a href="https://wa.me/541178543970" target="_blank" rel="noopener" class="footer-city-phone">
                  <i class="bi bi-telephone-fill"></i>+54 11 7854 3970
                </a>
              </li>
            </ul>
          </li>
          <li>
            <button class="footer-accordion-toggle" (click)="toggleSection('colombia')" [class.open]="openSection === 'colombia'">
              Colombia<i class="bi" [ngClass]="openSection === 'colombia' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
            <ul class="footer-submenu" [class.open]="openSection === 'colombia'">
              <li class="footer-city-item">
                <span class="footer-city-name">Bogotá</span>
                <a href="https://wa.me/573138897876" target="_blank" rel="noopener" class="footer-city-phone">
                  <i class="bi bi-telephone-fill"></i>+57 313 889 7876
                </a>
              </li>
              <li class="footer-city-item">
                <span class="footer-city-name">Medellín</span>
                <a href="https://wa.me/573233932626" target="_blank" rel="noopener" class="footer-city-phone">
                  <i class="bi bi-telephone-fill"></i>+57 323 393 2626
                </a>
              </li>
            </ul>
          </li>
          <li>
            <button class="footer-accordion-toggle" (click)="toggleSection('eeuu')" [class.open]="openSection === 'eeuu'">
              EE.UU<i class="bi" [ngClass]="openSection === 'eeuu' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
          </li>
        </ul>
      </div>

      
      <div class="footer-col">
        <h6 class="footer-col-title">Servicios</h6>
        <ul class="footer-list simple">
          <li><a routerLink="/home">Vuelos</a></li>
          <li><a routerLink="/home">Hoteles</a></li>
          <li><a routerLink="/home">Tours</a></li>
          <li><a routerLink="/home">Seguros</a></li>
          <li><a routerLink="/home">Visa y documentos</a></li>
        </ul>
      </div>

      
      <div class="footer-col">
        <h6 class="footer-col-title">Metodo de pago</h6>
        <ul class="footer-payment-logos">
          <li><img src="assets/images/element/paypal.svg" alt="PayPal" class="payment-logo" /></li>
          <li><img src="assets/images/element/visa.svg" alt="Visa" class="payment-logo" /></li>
          <li><img src="assets/images/element/mastercard.svg" alt="Mastercard" class="payment-logo" /></li>
          <li><img src="assets/images/element/expresscard.svg" alt="American Express" class="payment-logo" /></li>
          <li><img src="assets/images/element/scalapay.svg" alt="Scalapay" class="payment-logo scalapay-logo" /></li>
          <li><img src="assets/images/partners/affirm.svg" alt="Affirm" class="payment-logo" /></li>
          <li><img src="assets/images/partners/klarna.svg" alt="Klarna" class="payment-logo" /></li>
          <li><img src="assets/images/partners/afterpay.svg" alt="Afterpay" class="payment-logo" /></li>
          <li><img src="assets/images/partners/wompi.png" alt="Wompi" class="payment-logo wompi-logo" /></li>
        </ul>
      </div>

      
      <div class="footer-col">
        <h6 class="footer-col-title">Soporte y políticas</h6>
        <ul class="footer-list simple">
          <li><a [routerLink]="['/policies']" [queryParams]="{ tab: 'reembolsos' }">Reembolsos</a></li>
          <li><a [routerLink]="['/policies']" [queryParams]="{ tab: 'devoluciones' }">Devoluciones</a></li>
          <li><a [routerLink]="['/policies']" [queryParams]="{ tab: 'cancelaciones' }">Cancelaciones</a></li>
          <li><a [routerLink]="['/policies']" [queryParams]="{ tab: 'terminos' }">Terminos y condiciones</a></li>
          <li><a href="mailto:info@arcadia-viajes.com" target="_blank" rel="noopener">Centro de ayuda</a></li>
          <li><a [routerLink]="['/policies']" [queryParams]="{ tab: 'privacidad' }">Política de privacidad</a></li>
          <li><a href="/assets/images/home/PROCEDIMIENTO-CANAL-DENUNCIAS.pdf" target="_blank" rel="noopener">Proceso de denuncia</a></li>
        </ul>
      </div>

    </div>
    

    
    <div class="footer-mobile d-lg-none">

      
      <div class="footer-brand-mobile">
        <a routerLink="/">
          <img src="assets/images/logo.svg" alt="Arcadia" class="footer-logo-mobile" style="width:177px;min-width:177px;height:auto;" />
        </a>
        <p class="footer-tagline-mobile">
          Tu agencia de viajes de confianza.<br />
          Creando experiencias inolvidables
        </p>
        
        <div class="footer-socials-mobile">
          <a href="https://www.facebook.com/agenciaarcadiaviajes/?locale=es_LA" target="_blank" rel="noopener" aria-label="Facebook">
            <i class="fab fa-facebook-f"></i>
          </a>
          <a href="https://www.instagram.com/arcadia.viajes/" target="_blank" rel="noopener" aria-label="Instagram">
            <i class="fab fa-instagram"></i>
          </a>
          <a href="https://www.tiktok.com/@viajaarcadia?_r=1&_t=ZS-96AqKCnOpIG" target="_blank" rel="noopener" aria-label="TikTok">
            <i class="fab fa-tiktok"></i>
          </a>
          <a href="https://www.linkedin.com/company/arcadia-viajes/" target="_blank" rel="noopener" aria-label="LinkedIn">
            <i class="fab fa-linkedin-in"></i>
          </a>
          
          <a href="mailto:info@arcadia-viajes.com" aria-label="Correo electrónico" class="footer-social-email">
            <i class="bi bi-envelope"></i>
          </a>
        </div>
      </div>

      
      <div class="footer-mob-accordions">

        
        <div class="footer-mob-section" [class.open]="openSection === 'mob-oficinas'">
          <button class="footer-mob-header" (click)="toggleSection('mob-oficinas')">
            <span>Oficinas</span>
            <i class="bi" [ngClass]="openSection === 'mob-oficinas' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </button>
          <div class="footer-mob-body">
            <ul class="footer-list">
              <li>
                <button class="footer-accordion-toggle" (click)="toggleSection('m-venezuela')" [class.open]="openSection === 'm-venezuela'">
                  Venezuela<i class="bi" [ngClass]="openSection === 'm-venezuela' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                </button>
                <ul class="footer-submenu" [class.open]="openSection === 'm-venezuela'">
                  <li class="footer-city-item">
                    <span class="footer-city-name">Caracas</span>
                    <a href="https://wa.me/584241542685" target="_blank" rel="noopener" class="footer-city-phone">
                      <i class="bi bi-telephone-fill"></i>+58 424 154 2685
                    </a>
                  </li>
                  <li class="footer-city-item">
                    <span class="footer-city-name">Valencia</span>
                    <a href="https://wa.me/584244097684" target="_blank" rel="noopener" class="footer-city-phone">
                      <i class="bi bi-telephone-fill"></i>+58 424 409 7684
                    </a>
                  </li>
                  <li class="footer-city-item">
                    <span class="footer-city-name">Barquisimeto</span>
                    <a href="https://wa.me/584245239195" target="_blank" rel="noopener" class="footer-city-phone">
                      <i class="bi bi-telephone-fill"></i>+58 424 523 9195
                    </a>
                  </li>
                  <li class="footer-city-item">
                    <span class="footer-city-name">Lechería</span>
                  </li>
                  <li class="footer-city-item">
                    <span class="footer-city-name">San Cristóbal</span>
                  </li>
                </ul>
              </li>
              <li>
                <button class="footer-accordion-toggle" (click)="toggleSection('m-espana')" [class.open]="openSection === 'm-espana'">
                  España<i class="bi" [ngClass]="openSection === 'm-espana' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                </button>
                <ul class="footer-submenu" [class.open]="openSection === 'm-espana'">
                  <li class="footer-city-item">
                    <span class="footer-city-name">Madrid</span>
                    <a href="https://wa.me/34655204586" target="_blank" rel="noopener" class="footer-city-phone">
                      <i class="bi bi-telephone-fill"></i>+34 655 204 586
                    </a>
                  </li>
                  <li class="footer-city-item">
                    <span class="footer-city-name">Barcelona</span>
                    <a href="https://wa.me/34655205035" target="_blank" rel="noopener" class="footer-city-phone">
                      <i class="bi bi-telephone-fill"></i>+34 655 205 035
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <button class="footer-accordion-toggle" (click)="toggleSection('m-argentina')" [class.open]="openSection === 'm-argentina'">
                  Argentina<i class="bi" [ngClass]="openSection === 'm-argentina' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                </button>
                <ul class="footer-submenu" [class.open]="openSection === 'm-argentina'">
                  <li class="footer-city-item">
                    <span class="footer-city-name">Buenos Aires</span>
                    <a href="https://wa.me/541178543970" target="_blank" rel="noopener" class="footer-city-phone">
                      <i class="bi bi-telephone-fill"></i>+54 11 7854 3970
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <button class="footer-accordion-toggle" (click)="toggleSection('m-colombia')" [class.open]="openSection === 'm-colombia'">
                  Colombia<i class="bi" [ngClass]="openSection === 'm-colombia' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                </button>
                <ul class="footer-submenu" [class.open]="openSection === 'm-colombia'">
                  <li class="footer-city-item">
                    <span class="footer-city-name">Bogotá</span>
                    <a href="https://wa.me/573138897876" target="_blank" rel="noopener" class="footer-city-phone">
                      <i class="bi bi-telephone-fill"></i>+57 313 889 7876
                    </a>
                  </li>
                  <li class="footer-city-item">
                    <span class="footer-city-name">Medellín</span>
                    <a href="https://wa.me/573233932626" target="_blank" rel="noopener" class="footer-city-phone">
                      <i class="bi bi-telephone-fill"></i>+57 323 393 2626
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <button class="footer-accordion-toggle" (click)="toggleSection('m-eeuu')" [class.open]="openSection === 'm-eeuu'">
                  EE.UU<i class="bi" [ngClass]="openSection === 'm-eeuu' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                </button>
              </li>
            </ul>
          </div>
        </div>

        
        <div class="footer-mob-section" [class.open]="openSection === 'mob-servicios'">
          <button class="footer-mob-header" (click)="toggleSection('mob-servicios')">
            <span>Servicios</span>
            <i class="bi" [ngClass]="openSection === 'mob-servicios' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </button>
          <div class="footer-mob-body">
            <ul class="footer-list simple">
              <li><a routerLink="/home">Vuelos</a></li>
              <li><a routerLink="/home">Hoteles</a></li>
              <li><a routerLink="/home">Tours</a></li>
              <li><a routerLink="/home">Seguros</a></li>
              <li><a routerLink="/home">Visa y documentos</a></li>
            </ul>
          </div>
        </div>

        
        <div class="footer-mob-section" [class.open]="openSection === 'mob-pago'">
          <button class="footer-mob-header" (click)="toggleSection('mob-pago')">
            <span>Metodo de pago</span>
            <i class="bi" [ngClass]="openSection === 'mob-pago' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </button>
          <div class="footer-mob-body">
            <ul class="footer-payment-logos horizontal">
              <li><img src="assets/images/element/paypal.svg" alt="PayPal" class="payment-logo" /></li>
              <li><img src="assets/images/element/visa.svg" alt="Visa" class="payment-logo" /></li>
              <li><img src="assets/images/element/mastercard.svg" alt="Mastercard" class="payment-logo" /></li>
              <li><img src="assets/images/element/expresscard.svg" alt="American Express" class="payment-logo" /></li>
              <li><img src="assets/images/element/scalapay.svg" alt="Scalapay" class="payment-logo scalapay-logo" /></li>
              <li><img src="assets/images/partners/affirm.svg" alt="Affirm" class="payment-logo" /></li>
              <li><img src="assets/images/partners/klarna.svg" alt="Klarna" class="payment-logo" /></li>
              <li><img src="assets/images/partners/afterpay.svg" alt="Afterpay" class="payment-logo" /></li>
              <li><img src="assets/images/partners/wompi.png" alt="Wompi" class="payment-logo wompi-logo" /></li>
            </ul>
          </div>
        </div>

        
        <div class="footer-mob-section" [class.open]="openSection === 'mob-soporte'">
          <button class="footer-mob-header" (click)="toggleSection('mob-soporte')">
            <span>Soporte y políticas</span>
            <i class="bi" [ngClass]="openSection === 'mob-soporte' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </button>
          <div class="footer-mob-body">
            <ul class="footer-list simple">
              <li><a [routerLink]="['/policies']" [queryParams]="{ tab: 'reembolsos' }">Reembolsos</a></li>
              <li><a [routerLink]="['/policies']" [queryParams]="{ tab: 'devoluciones' }">Devoluciones</a></li>
              <li><a [routerLink]="['/policies']" [queryParams]="{ tab: 'cancelaciones' }">Cancelaciones</a></li>
              <li><a [routerLink]="['/policies']" [queryParams]="{ tab: 'terminos' }">Terminos y condiciones</a></li>
              <li><a href="mailto:info@arcadia-viajes.com" target="_blank" rel="noopener">Centro de ayuda</a></li>
              <li><a [routerLink]="['/policies']" [queryParams]="{ tab: 'privacidad' }">Política de privacidad</a></li>
              <li><a href="/assets/images/home/PROCEDIMIENTO-CANAL-DENUNCIAS.pdf" target="_blank" rel="noopener">Proceso de denuncia</a></li>
              <!-- <li><a href="#" (click)="openComplaintModal($event)">Canal de denuncias 1</a></li> -->
              <li><a href="https://dabocanaldenuncia.com/ARCADIAVIAJESINOLVIDABLES" target="_blank" rel="noopener noreferrer">Canal de denuncias</a></li>
            </ul>
          </div>
        </div>

      </div>
    </div>
    

    
    <div class="footer-bottom">
      <span class="footer-copyright">© 2025 Arcadia Viajes Internacional. Todos los derechos reservados.</span>
      <nav class="footer-legal-links">
        <!-- <a href="#" (click)="openComplaintModal($event)">Canal de denuncias 1</a> -->
        <a href="https://dabocanaldenuncia.com/ARCADIAVIAJESINOLVIDABLES" target="_blank" rel="noopener noreferrer">Canal de denuncias</a>
      </nav>
    </div>

  </div>
</footer>